import { render, staticRenderFns } from "./PageOrdinaryPackage.vue?vue&type=template&id=08714606&scoped=true"
import script from "./PageOrdinaryPackage.vue?vue&type=script&lang=js"
export * from "./PageOrdinaryPackage.vue?vue&type=script&lang=js"
import style0 from "./PageOrdinaryPackage.vue?vue&type=style&index=0&id=08714606&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08714606",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08714606')) {
      api.createRecord('08714606', component.options)
    } else {
      api.reload('08714606', component.options)
    }
    module.hot.accept("./PageOrdinaryPackage.vue?vue&type=template&id=08714606&scoped=true", function () {
      api.rerender('08714606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/spu/components/PageOrdinaryPackage.vue"
export default component.exports